import React, {Component} from 'react';
import DocumentTitle from 'react-document-title';

export default class DocumentTitleComponent extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    buildTitle(text) {
        const root = window.config.page_title;
        if (text) {
            text = `${text.charAt(0).toUpperCase()}${text.slice(1)}`;
            return `${text} | ${root || ''}`;
        }
        return root || '';
    }

    render() {
        const {
            title,
            children,
            ...restprops
        } = this.props;
        return (
            <DocumentTitle title={this.buildTitle(title)} {...restprops}>
                {children}
            </DocumentTitle>
        );
    }

}



// WEBPACK FOOTER //
// ./src/js/components/document-title.jsx